import { render, staticRenderFns } from "./ClinicianCustomizeMeasure.vue?vue&type=template&id=42bdc3c8"
import script from "./ClinicianCustomizeMeasure.vue?vue&type=script&lang=js"
export * from "./ClinicianCustomizeMeasure.vue?vue&type=script&lang=js"
import style1 from "./ClinicianCustomizeMeasure.vue?vue&type=style&index=1&id=42bdc3c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports